import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungReutlingen() {
  return (
    <CityPageTemplate
      city="Reutlingen"
      slug="reutlingen"
      intro="Reutlingen als Wirtschaftszentrum der Schwäbischen Alb – Deine Finanzen sollten genauso solide sein."
      description="Unabhängige & digitale Finanzberatung für Reutlingen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
